<kiene-kiene-table [tableDescriptor]="openTableDescriptor"> </kiene-kiene-table>
